import { useMemo } from 'react'

import { GET_BATCH } from 'src/queries/GET_BATCH'
import { GetBatch, GetBatchVariables } from 'src/queries/types/GetBatch'
import { EBatchStatus } from 'src/types/enums/EBatchStatus'

import { useQuery } from '@apollo/client'
import Notification from 'src/resources/elements/Notification'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import { DefaultTheme } from './ThemeWrapper'

interface IErrorMessage {
  title: string
  message: string
}

export function EmbedsErrorBanner({
  batchId,
  allInvalid
}: {
  batchId: string
  allInvalid: boolean
}) {
  const { t } = useTranslation()
  const theme = useTheme() as DefaultTheme
  const { data } = useQuery<GetBatch, GetBatchVariables>(GET_BATCH, {
    fetchPolicy: 'cache-and-network',
    variables: {
      batchId
    }
  })

  const showBanner = useMemo(() => {
    if (data?.getBatch?.status === EBatchStatus.dataHookError) {
      return 'dataHooksErr'
    }
    if (allInvalid && data?.getBatch?.synced) {
      return 'allInvalidErr'
    }
  }, [data, allInvalid])

  const errorMessageMap: { [key: string]: IErrorMessage } = {
    dataHooksErr: {
      title: 'fragments.EmbedsErrorBanner.dataHooksErr.title',
      message: 'fragments.EmbedsErrorBanner.dataHooksErr.message'
    },
    allInvalidErr: {
      title: theme.textOverrides.allInvalidErrHeading,
      message: theme.textOverrides.allInvalidErrDescription
    }
  }

  return !!showBanner ? (
    <Notification fullWidth type='warning' title={t(errorMessageMap[showBanner].title)}>
      {t(errorMessageMap[showBanner].message)}
    </Notification>
  ) : null
}
